import React from 'react';
import { BreadcrumbItem } from '@here/hds-breadcrumb';
new BreadcrumbItem();
const HDSBreadcrumbItem = React.forwardRef(({ active, children, className, ...rest }, ref) => (React.createElement("hds-breadcrumb-item", { ...(active && { active }), ...(className && { class: className }), ref: ref, ...rest }, children)));
HDSBreadcrumbItem.defaultProps = {
    active: false,
};
export default HDSBreadcrumbItem;
//# sourceMappingURL=HDSBreadcrumbItem.js.map